module.exports = __webpack_public_path__ + "img/lazada-logo-connect.f9e36698.png";